var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sign"},[_c('div',{staticClass:"hor"}),_c('div',{staticClass:"vert"})])])
}]

export { render, staticRenderFns }